const regex = new RegExp(
  /^[0-9()+\\\-*.\/{}a-zA-Z\s]*$|(?:\{\{[\w.-]+\}\}(?:\/\{\{[\w.-]+\}\})*)+/,
)

export const validateVariableFormula = (formula: unknown): boolean =>
  typeof formula === 'string' && !!formula && regex.test(formula)
